import { compose } from 'lodash/fp';
import { paletteLookup, paletteValidator } from './functions';

const backgroundPalette = {
   100: '#FFFFFF',
   200: '#F2F2F2',
   300: '#EBEBEB',
   400: '#E2E2E2',
   500: '#DBDBDB',
   600: '#D4D4D4',
   700: '#C6C6C6',
   800: '#C0C0C0',
   900: '#BBBBBB',
   1000: '#B5B5B5',
   1100: '#AEAEAE',
   1200: '#A7A7A7',
   1300: '#A2A2A2',
   1400: '#9D9D9D',
   1500: '#979797',
   1600: '#929292',
   1700: '#8D8D8D',
   1800: '#888888'
};

const getBackgroundPalette = compose(paletteLookup(backgroundPalette), paletteValidator(100, 1800));

export default getBackgroundPalette;



// WEBPACK FOOTER //
// ./src/UI/themes/background.js